class ChoisePaiement {
  constructor() {
    this._init();
  }

  _init() {
    // Select both option items using data attribute
    const items = document.querySelectorAll('[data-paiement-option]');

    items.forEach(item => {
      item.addEventListener('click', () => {
        // Remove active class from all items
        items.forEach(el => el.classList.remove('active'));

        // Add active class to clicked item
        item.classList.add('active');

        // Find and check the hidden radio input inside this item
        const radio = item.querySelector(
          'input[type="radio"]'
        ) as HTMLInputElement;
        if (radio) {
          radio.checked = true;
        }
      });
    });
  }
}

export const componentChoisePaiement = new ChoisePaiement();
